<div class="title__worker-type text-italic" [ngbPopover]="userPopContent" placement="bottom-left" triggers="manual" #p2="ngbPopover" (click)="toggleWithUserContext(p2)">
  <a class="link {{ 'link--dotted-' + Enums.userHighlightTypes[user.employer.employee_type.et_id] }}">
    {{ Enums.userTypes[user.employer.employee_type.et_id] }}
  </a>
</div>

<ng-template #userPopContent>
  <div class="font-weight-bold">
    <a [routerLink]="['/users', { u_id: user.u_id }]" class="link">{{ user.employee.full_name }}</a>
  </div>
  <div class="color-gray-dark">
    <div *ngIf="user.is_brigade_head">Бригадир</div>
    <div>{{ user.brigade && user.brigade.brigade_name }}</div>
  </div>
  <div class="mt-16">
    <div class="font-weight-bold color-blue-dark">
      {{ user.employer.service_function_name }}
    </div>
    <div>{{ user.employer.service_function_description }}</div>
  </div>
  <div class="mt-16 color-gray-dark">
    <div class="grid grid--gap-4">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'hd-phone-2'" [size]="'14'" [color]="'gray'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="text-italic">
          {{ user.employee.phone | phoneFormat }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
